import {
  MODERATOR_ROLE,
  PRODUCT_MANAGER_ROLE,
  SALES_MANAGER_ROLE,
  SALES_REP_ROLE,
  getUserRoles,
  AppRole,
} from './roleConstants';
import { can } from './permissions';

export type { AppRole } from './roleConstants';
export {
  ADMIN_ROLE,
  MODERATOR_ROLE,
  PRODUCT_MANAGER_ROLE,
  SALES_MANAGER_ROLE,
  SALES_REP_ROLE,
  getUserRoles,
} from './roleConstants';

export { ASSIGNABLE_ROLES, can, canAny } from './permissions';
export type { Permission } from './permissions';

export const hasRole = (user: { roles?: string[] } | null, role: AppRole): boolean =>
  getUserRoles(user).includes(role);

export const hasAnyRole = (
  user: { roles?: string[] } | null,
  roles: AppRole[]
): boolean => roles.some((role) => hasRole(user, role));

export const isAdmin = (user: { roles?: string[] } | null): boolean =>
  can(user, 'users.manage');

export const isModerator = (user: { roles?: string[] } | null): boolean =>
  hasRole(user, MODERATOR_ROLE);

export const isProductManager = (user: { roles?: string[] } | null): boolean =>
  hasRole(user, PRODUCT_MANAGER_ROLE) || hasRole(user, MODERATOR_ROLE);

export const isSalesManager = (user: { roles?: string[] } | null): boolean =>
  hasRole(user, SALES_MANAGER_ROLE) || hasRole(user, SALES_REP_ROLE);

/** @deprecated legacy alias — use isSalesManager */
export const isSalesRep = isSalesManager;

export const canAccessApp = (user: { roles?: string[] } | null): boolean =>
  can(user, 'app.access');

export const canAccessMagazine = (user: { roles?: string[] } | null): boolean =>
  can(user, 'magazine.access');

export const canAccessOpsNav = (user: { roles?: string[] } | null): boolean =>
  can(user, 'ops.read');

export const canAccessCompanies = (user: { roles?: string[] } | null): boolean =>
  can(user, 'companies.read');

export const canEditCompanies = (user: { roles?: string[] } | null): boolean =>
  can(user, 'companies.write');

export const canEditContacts = (user: { roles?: string[] } | null): boolean =>
  can(user, 'contacts.write');

export const canEditAnyDeal = (user: { roles?: string[] } | null): boolean =>
  can(user, 'deals.write.any');

export const canManageMagazineCatalog = (user: { roles?: string[] } | null): boolean =>
  can(user, 'magazine.catalog.write');

export const canViewMagazineReports = (user: { roles?: string[] } | null): boolean =>
  can(user, 'magazine.reports');

export const canViewSalesReports = (user: { roles?: string[] } | null): boolean =>
  can(user, 'reports.read');

export const canManageUsers = (user: { roles?: string[] } | null): boolean =>
  can(user, 'users.manage');

export const getDefaultLandingPath = (user: { roles?: string[] } | null): string => {
  if (isSalesManager(user)) return '/dashboard';
  if (isProductManager(user) || isModerator(user)) return '/events';
  return '/dashboard';
};
